module.exports = __webpack_public_path__ + "static/media/YF33_2.1cdc8504.jpg";